// extracted by mini-css-extract-plugin
export default {"HeaderLogo":"HeaderLogo_HeaderLogo__e8a9t","HeaderLogoLink":"HeaderLogo_HeaderLogoLink__YRnda","Centered":"HeaderLogo_Centered__lemI7"};